import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zm-2 10l-2.5-1.5L15 12V4h5v8z"
}), 'CollectionsBookmarkSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CollectionsBookmarkSharp.js
// module id = 2872
// module chunks = 2